var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H11V13H13V11Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H13V15H15V13Z",
    fill: "#535F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H17V15H19V13Z",
    fill: "#535F79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15H15V17H17V15Z",
    fill: "#535F79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H15V13H17V11Z",
    fill: "#535F79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H11V17H13V15Z",
    fill: "#535F79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H17V19H19V17Z",
    fill: "#535F79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H13V19H15V17Z",
    fill: "#535F79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3C11 1.34315 12.3431 0 14 0H17C18.6569 0 20 1.34315 20 3V6C20 7.65685 18.6569 9 17 9H14C12.3431 9 11 7.65685 11 6V3Z",
    fill: "#535F79"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14C0 12.3431 1.34315 11 3 11H6C7.65685 11 9 12.3431 9 14V17C9 18.6569 7.65685 20 6 20H3C1.34315 20 0 18.6569 0 17V14Z",
    fill: "#535F79"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H6C7.65685 0 9 1.34315 9 3V6C9 7.65685 7.65685 9 6 9H3C1.34315 9 0 7.65685 0 6V3Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.d73785adcf4f709dd6b12d53db5ed701.svg";
export { ForwardRef as ReactComponent };